// src/components/ui/DashboardSection.jsx

import React from 'react';
import SectionHeader from './SectionHeader';
import { PAGE, getDashboardCardStyle, getSectionHeaderStyle } from './pageTheme';

export default function DashboardSection({
  title,
  subtitle,
  headerExtra,
  children,
  bodyPadding = 24,
  style,
  headerStyle,
  bodyStyle,
}) {
  return (
    <section style={getDashboardCardStyle(style)}>
      {(title || subtitle || headerExtra) && (
        <div
          style={{
            ...getSectionHeaderStyle(),
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            gap: PAGE.gap,
            flexWrap: 'wrap',
            ...headerStyle,
          }}
        >
          <SectionHeader title={title} subtitle={subtitle} />
          {headerExtra}
        </div>
      )}
      <div style={{ padding: bodyPadding, ...bodyStyle }}>{children}</div>
    </section>
  );
}
